{
  "title": "Workbench",
  "today": {
    "heading": "Today",
    "empty": "No sessions today",
    "emptyRoster": "This session has no students"
  },
  "badge": {
    "pending": "Attendance pending",
    "done": "Attendance taken",
    "empty": "No students",
    "locked": "Month closed"
  },
  "day": {
    "backToToday": "Back to today",
    "status": "{{count}} session(s) · {{state}}",
    "statusDone": "attendance complete",
    "statusPending": "{{n}} session(s) still need attendance",
    "statusNone": "no sessions",
    "banner": "You are viewing {{day}} — editing attendance on a past day is fine; next month’s invoice reconciles it.",
    "emptyTitle": "No sessions on this day",
    "emptyBody": "Pick another day on the week strip, or add a one-off session for a makeup class.",
    "noSlotTitle": "Nothing scheduled yet",
    "noSlotBody": "Create a class on the Classes page; sessions and attendance are generated from it.",
    "noSlotCta": "Create a slot"
  },
  "card": {
    "sessionDetail": "Session detail"
  },
  "week": {
    "thisWeek": "This week",
    "prev": "Previous week",
    "next": "Next week",
    "legend": {
      "done": "Attendance taken",
      "pending": "Attendance pending",
      "future": "Upcoming"
    },
    "pickDay": "Pick a day",
    "viewMonth": "See the whole month →"
  },
  "gettingStarted": {
    "title": "Getting started with LopHoc",
    "progress": "{{done}}/{{total}}",
    "progressLabel": "{{done}} of {{total}} steps done",
    "menuLabel": "Getting-started card options",
    "dismiss": "Hide",
    "next": "next step",
    "steps": {
      "subject": {
        "title": "Create a subject",
        "desc": "The subject decides the per-session / per-month price."
      },
      "slot": {
        "title": "Create a weekly time slot",
        "desc": "Sessions and attendance are generated from it."
      },
      "student": {
        "title": "Add a student",
        "desc": "Name and who pays — nothing else needed yet."
      },
      "enrolled": {
        "title": "Add an enrollment",
        "desc": "Tie them to a subject and a way of paying — that's what creates tuition.",
        "hint": "Open a student → Thêm đăng ký"
      },
      "placed": {
        "title": "Place them in a class",
        "desc": "Put the student in a time slot; that is what creates sessions to mark.",
        "hint": "Open a student → Xếp lớp"
      },
      "attendance": {
        "title": "Take attendance for the first session",
        "desc": "Attendance is where invoices come from."
      }
    },
    "footerBefore": "At month end: ",
    "footerTerm": "Chốt sổ",
    "footerAfter": " turns attendance into invoices — under Chốt sổ & Hoá đơn."
  },
  "attention": {
    "title": "Needs attention",
    "countLabel": "{{count}} items need attention",
    "chot": {
      "pending": {
        "title": "Close the month of {{month}}",
        "desc": "{{count}} session(s) in month {{prev}} still need attendance — mark them, then close to reconcile correctly"
      },
      "owed": {
        "title": "Month {{owed}} is not fully closed",
        "desc": "Close that month first, then close month {{month}} — otherwise it will never be reconciled"
      },
      "ready": {
        "title": "Close the month of {{month}}",
        "desc": "Attendance is complete — close the month to send invoices to parents"
      },
      "action": "Close the month"
    },
    "termOut": {
      "title": "{{student}} has used up the block",
      "desc": "Collect payment now so the next session isn't taught on credit"
    },
    "termNearlyOut": {
      "title": "{{student}} is nearly out of sessions",
      "desc": "{{count}} session(s) left — remind the parent to pay before the block runs out"
    },
    "term": {
      "action": "View student"
    },
    "termMore": {
      "title": "and {{count}} more student(s)",
      "action": "View list"
    },
    "unmatched": {
      "title": "{{count}} unmatched transaction(s) · {{total}}",
      "desc": "Money has arrived in the account but couldn't be matched to any invoice",
      "action": "Reconcile"
    },
    "reconcileExhausted": {
      "title": "Auto-matching is paused for this month",
      "desc": "Transfers still reach your bank account, but you'll need to mark those invoices paid by hand. It reopens next month.",
      "action": "View plan"
    },
    "monthlyReview": {
      "action": "Write review"
    }
  },
  "loadError": "Could not load today's sessions",
  "oneOff": {
    "link": "Add a one-off / makeup session for this day",
    "title": "Add a one-off / makeup session",
    "forDay": "The session will be added on {{day}}",
    "subject": "Subject",
    "pickSubject": "Pick a subject",
    "students": "Students",
    "pickStudents": "Pick students",
    "selectedCount": "{{n}} student(s)",
    "removeStudent": "Remove",
    "whatIsAria": "What is a one-off session?",
    "whatIsTitle": "A one-off session",
    "whatIs1": "is added to this day only — it is not part of the timetable and does not repeat next week. Use it for a makeup or an extra class.",
    "whatIs2": "Attendance works as normal; students who pay per session will have it counted in the next month-close.",
    "whatIs3": "If a session for the same subject already exists at that exact time, the students are merged into it instead of a new session being created.",
    "noEnrollments": "No active enrollments yet"
  }
}
